import { styled, Tag } from '@project44/manifest-ds';

export const Container = styled('div', {
  background: '$background-primary',
  boxShadow: '$small',
  borderRadius: '$small',
  marginBottom: '$medium',
});

export const Header = styled('div', {
  padding: '$medium',
});

export const Content = styled('div', {
  borderTop: '1px solid $border-primary',
});

export const Footer = styled('div', {
  borderTop: '1px solid $border-primary',
  padding: '0.75rem $medium',
});

export const StatusBadge = styled(Tag, {
  backgroundColor: '$palette-indigo-50',
  borderColor: '$palette-indigo-50',
  color: '$palette-indigo-700',
  marginRight: '30px',
  '& > *': {
    padding: '2px',
    paddingRight: '$small',
  },
});

export const LengthContainer = styled('div', {
  background: '$background-secondary',
  borderRadius: 4,
  fontSize: 10,
  color: '$text-secondary',
  padding: '0 8px',
  display: 'flex',
  flexDirection: 'column',
  flexWrap: 'wrap',
  alignContent: 'center',
  justifyContent: 'center',
  marginLeft: 8,
});

export const TitleContainer = styled('div', {
  display: 'flex',
  alignItems: 'center',
  fontWeight: '$bold',
});
